import { toast } from "react-toastify";
import { Address } from "../API/Address/ViewAllAddedAddressByUserAsync";
import { getApiBaseUrl } from "../utils/apiBaseUrl";

/**
 * @param addressId - The ID of the address to fetch.
 * @param token - The authentication token.
 * @returns A promise that resolves to an array of Address objects.
 */
export async function viewAddressByIdAsync(
  addressId: string,
  token: string,
  t: (key: string) => string
): Promise<Address | null> {

  if (!navigator.onLine) {
    toast.error(t("internetConnection"), { toastId: "offline-error" });
    return null;
  }

  try {
    const baseUrl = getApiBaseUrl();
    const response = await fetch(
      `${baseUrl}/api/Admin/ViewAddressByIdAsync?addressId=${addressId}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`${errorData.message}`);
    }

    const data: Address = await response.json();
    return data;

  } catch (error) {
    // console.error("Error fetching address details:", error);
    throw error;
  }
}


